import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatChipsModule } from "@angular/material/chips";

import type { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from "ag-grid-community";

import { displayStatus, type DisplayStatus } from "../../utils/display-status.util";

@Component({
  selector: "status-chip-cell-renderer",
  imports: [MatChipsModule],
  template: `
    @if (status) {
      <mat-chip [class]="status.cssClass">{{ status.label }}</mat-chip>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "../../styles/status.global.css",
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class StatusChipCellRenderer implements ICellRendererAngularComp {
  public status: DisplayStatus | null = null;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  // Accepts a plain legacy string or a resolved DisplayStatus (see displayStatus()).
  refresh(params: ICellRendererParams<unknown, string | DisplayStatus | null>): boolean {
    const value = params.value;
    this.status = typeof value === "string" ? displayStatus(null, value) : (value ?? null);
    return true;
  }
}
